import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { DriverAssignment } from "../../order/model/invoice.model";
import { Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { Party } from "./party.model";

export class Personnel extends EntityBase {
  public PartyId: number;
  public IsActive?: boolean;
  public FirstName: string;
  public LastName: string;
  public DisplayName: string;
  public Description: string;
  public Number?: number;
  public BailTypeId: number;
  public BailTypeTitle: string;
  public BailPrice?: number;
  public Introducer: string;
  public TerminalNumber: string;
  public HealthNumber: string;
  public HealthExpirationDate?: Date;
  public Address: string;
  public RowVersion: any;
  public PhoneNumber: string;
  public MobileNumber: string;
  public UserId?: number;
  public UserDisplayName: string;
  public LicenseNumber: string;
  public LicenseExpirationDate?: Date;
  public InsuranceNumber: string;
  public InsuranceExpirationDate?: Date;
  public HasCredit: boolean;
  public CreditLimit?: number;
  public CreditControlTypeId?: number;
  public CreditControlTypeTitle: string;
  public CreditControlTypeCode?: number;
  public Order: number;
  public DriverAssignmentInvoicesCount: number;
  public AssignmentInvoicesTotal: number;
  public SelectedInvoicesTotal: number;
  public DriverAssignmentIds: number[];
  public DriverAssignments: DriverAssignment[];
  public Branches: PersonnelBranch[];
  public CurrentBranch: PersonnelBranch;
  public Documents: PersonnelDocuments[];
  public Roles: PersonnelRoles[];
  public RolesTitle: string;
  public selected: boolean;
  public FilterDate: string;
  public DefaultSalonId?: number;
  public DetailLedgerId?: number;
  public SubLedgerId?: number;
  public DefaultSalonsTitle: string;
  public CanUseOtherTable: boolean;
  public VehiclePlateNumber: string;
  public VehicleVinCode: string;
  public NationalCode: string;
  public VehicleColor: string;
  public VehicleCapacity: string;
  public VehicleEngineVolume: string;
  public VehicleEngineCode: string;
  public VehicleChassisCode: string;
  public BailPriceTypeCode?: number;
  public Party: Party;
  public IsFleet?: boolean;
  public Image: string;
  public Freeze: boolean;
}

export class PersonnelBranch extends EntityBase {
  public Selected: boolean;
  public BranchId: number;
  public IsActive: boolean;
  public BranchTitle: string;
  public PersonnelId: number;
  public VehicleId: number;
  public FleetStatus: string;
  public DriverAttendanceStatusId?: number;
  public DriverAttendanceStatusTitle: string;
  public DriverAttendanceStatusCode?: number;
  public DriverStatusId?: number;
  public DriverStatusTitle: string;
  public DriverStatusCode?: number;
}

export class PersonnelDocuments extends EntityBase {
  public PersonnelId: number;
  public DocumentsId: number;
  public DocumentsTitle?: string;
}
export class PersonnelRoles extends EntityBase {
  public PersonnelId: number;
  public RolesId: number;
  public RolesTitle?: string;
  public PersonnelRole: Lookup;
}

export class FilterDriversByCode extends Personnel {
  public StartCode: number;
  public EndCode: number;
}

export enum PersonnelRolesEnum {
  Waiter = "مهماندار",
  Cashier = "صندوقدار",
  Driver = "پیک",
  Cooks = "آشپز",
  CooksHelper = "کمک آشپز",
  Employee = "سایر",
}
export enum PersonnelRolesCodeEnum {
  Waiter = 1,
  Cashier = 2,
  Driver = 3,
  Cooks = 4,
  CooksHelper = 5,
  Employee = 1000,
}
export enum DriverAttendanceStatus {
  Present = 1,
  Absent = 2,
}

export enum DriverStatus {
  In = 1,
  Out = 2,
  Present = 3,
  Absent = 4,
  Active = 5,
  Deactive = 6,
}

export enum DriverStatusShow {
  DriverIn = 0,
  DriverOut = 1,
  DriverReadyToWork = 2,
  All = 3,
}

export enum PersonnelState {
  In = 1,
  Out = 2,
  Present = 3,
  Absent = 4,
  Active = 5,
  Deactive = 6,
}
